import {connect} from 'react-redux';
import * as React from "react";
import GroupAdminState, {ContractGroup, GroupUser} from "../GroupAdminState";
import * as selectors from "../selectors";
import {
    addUserToGroup, AddUserToGroup, removeUserFromGroup, RemoveUserFromGroup,
    setUserRole,
    SetUserRole
} from "../actions";
import classNames = require("classnames");


interface ComponentState {
}

interface TagProps {
}

interface StateProps {
    selectedContractGroup: ContractGroup,
    users: GroupUser[];
    highlightedUsername: string;
}

interface DispatchProps {
    doSetUserRole: SetUserRole,
    doAddUser: AddUserToGroup,
    doRemoveUser: RemoveUserFromGroup,
}

const mapStateToProps = (state: GroupAdminState): StateProps => {
    return {
        selectedContractGroup: selectors.selectedContractGroup(state),
        users: selectors.selectedContractGroupUsers(state),
        highlightedUsername: selectors.highlightedUsername(state),
    };
};

const mapDispatchToProps: DispatchProps = ({
    doSetUserRole: setUserRole,
    doAddUser: addUserToGroup,
    doRemoveUser: removeUserFromGroup,
});

type Props = TagProps & StateProps & DispatchProps;

class UserManagerComponent extends React.Component<Props, ComponentState> {
    private usernameInput: HTMLInputElement;

    render() {

        let {selectedContractGroup, users, highlightedUsername} = this.props;

        if (!selectedContractGroup) return null;

        return (
            <div id="user-manager">
                <div className="contract-manager-head">
                    <h2>Brukere</h2>
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        this.handleAddUser(e);
                    }}>
                        <input ref={input => this.usernameInput = input} type="text" placeholder="brukernavn"/>
                        <button type="submit">Legg til</button>
                    </form>
                </div>

                <Userlist users={users}
                          handleRoleChange={this.handleRoleChange}
                          handleRemoveUser={this.handleRemoveUser}
                          highlightedUsername={highlightedUsername}/>
            </div>
        );
    }

    handleRoleChange = function (role: string, user: GroupUser) {
        console.log("Change role for user " + user.username + " to " + role);
        this.props.doSetUserRole(role, user.username, this.props.selectedContractGroup.id);
    }.bind(this);

    handleAddUser = function () {
        let username = this.usernameInput.value;
        if (username) {
            this.usernameInput.value = "";
            console.log("add user " + username);
            this.props.doAddUser(username, this.props.selectedContractGroup.id);
        }
    }.bind(this);

    handleRemoveUser = function (username: string) {
        console.log("remove user " + username + " from " + this.props.selectedContractGroup.name);
        this.props.doRemoveUser(username, this.props.selectedContractGroup.id);
    }.bind(this)
}

type CompareType = (a:GroupUser, b:GroupUser) => number;

const compareUserNames = (intlCollator:Intl.Collator):CompareType => {
    return function compareWithIntlCollator (a:GroupUser, b:GroupUser):number {
        let sortByA = a.displayname ? a.displayname : a.username;
        let sortByB = b.displayname ? b.displayname : b.username;
        return intlCollator.compare(sortByA, sortByB);
    }
  }

const sortUsers = (users:GroupUser[], intlCollator:Intl.Collator):GroupUser[] => {
    // Sorts users inplace
    users.sort(compareUserNames(intlCollator));
    return users;
}

interface UserlistProps {
    users: GroupUser[];
    handleRoleChange: Function;
    handleRemoveUser: Function;
    highlightedUsername?: string;
}

const Userlist = ({users, handleRoleChange, handleRemoveUser, highlightedUsername}: UserlistProps) => {
    
    if (users.length === 0) return (
        <p className="infobox">
            Ingen brukere i denne gruppen
        </p>
    );

    let intlCollator = Intl.Collator('nb', { numeric: true });

    return (
        <ul className="contract-manager-list">
            {sortUsers(users, intlCollator).map(user => {
                let liClasses = classNames({
                    "cml--element": true,
                    "highlighted": highlightedUsername == user.username
                });

                return (
                    <li className={liClasses} key={user.username}>
                        <div className="cml--content">
                            <p>
                                <span>{user.displayname}</span><br/>
                                <span className="color-mid-gray">{user.username}</span>
                            </p>
                            <select value={user.role} onChange={event => handleRoleChange(event.target.value, user)}>
                                <option value="DELTAKER">Deltaker</option>
                                <option value="CONTRACTGROUP_FORVALTER">Forvalter</option>
                                <option value="CONTRACTGROUP_ADMIN">Gruppeadministrator</option>
                            </select>
                        </div>
                        <div className="cml--tools">
                            <button onClick={() => handleRemoveUser(user.username)}>Fjern</button>
                        </div>
                    </li>
                )
            })}
        </ul>
    );
};

export const UserManager = connect(mapStateToProps, mapDispatchToProps)(UserManagerComponent);
